import { Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const LABEL = { proposal: "la propuesta", invoice: "la factura", quote: "la cotización" };
const create = (kind, id) => api.post("/share-links", { kind, ref_id: id }).then((r) => r.data);
const waNumber = (phone) => {
  const d = (phone || "").replace(/\D/g, "");
  return d.length === 10 ? `1${d}` : d;
};

export function ShareLinkButton({ kind, id, testid = "share-link-button" }) {
  const copy = async () => {
    try {
      const data = await create(kind, id);
      await navigator.clipboard.writeText(data.url).catch(() => window.prompt("Copie el enlace:", data.url));
      toast.success(`Enlace copiado. El cliente lo abre sin iniciar sesión durante ${data.days} días.`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return <Button variant="outline" onClick={copy} data-testid={testid}><Link2 className="mr-2 h-4 w-4" />Copiar enlace directo</Button>;
}

export function WhatsAppShareButton({ kind, id, testid = "whatsapp-share-button" }) {
  const send = async () => {
    const win = window.open("", "_blank");
    try {
      const d = await create(kind, id);
      const text = `Hola${d.client_name ? ` ${d.client_name}` : ""}, le comparto ${LABEL[kind]} ${d.number || ""} de RinoTECH. Puede abrirla aquí, sin crear cuenta (válido ${d.days} días): ${d.url}`;
      const num = waNumber(d.phone);
      const url = `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
      if (win) win.location.href = url; else window.location.href = url;
      if (!num) toast.info("El cliente no tiene teléfono registrado: elija el contacto en WhatsApp.");
    } catch (e) { if (win) win.close(); toast.error(errMsg(e)); }
  };
  return (
    <Button variant="outline" onClick={send} className="border-[#25D366] text-[#128C7E] hover:bg-[#25D366] hover:text-white" data-testid={testid}>
      <MessageCircle className="mr-2 h-4 w-4" />Enviar por WhatsApp
    </Button>
  );
}
